import { UNIFIED_DATA_VERSION } from '@hakimo-ui/hakimo/types';
import { useAtomValue } from 'jotai';
import { dataVersionOverrideAtom } from './state';

/**
 * The data version to put on a request, given the stored override.
 *
 * Rules, applied here once so call sites can't get them wrong:
 *  - only `v3` is sent — `v2` is the legacy default, so a v2 read must look
 *    byte-identical to a pre-unification request.
 */
export function useApiDataVersion(): typeof UNIFIED_DATA_VERSION | undefined {
  const override = useAtomValue(dataVersionOverrideAtom);
  return override === UNIFIED_DATA_VERSION ? UNIFIED_DATA_VERSION : undefined;
}
